import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faChalkboardUser,
  faClock,
  faMessage,
} from '@fortawesome/free-solid-svg-icons';

import './notification.scss';
import PropTypes from 'prop-types';

const truncateText = (text, maxLength = 100) => {
  if (!text) return '';
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};

export const getNotificationIcon = (value) => {
  const text = `${value?.subject || ''} ${value?.message || ''}`.toLowerCase();
  if (text.includes('shared')) {
    return faChalkboardUser;
  }
  if (text.includes('completed')) {
    return faCheck;
  }
  return faMessage;
};

const Notification = ({
  allMessage = [],
  notViewedAlerts = 0,
  viewAllMessageHandler,
  onMarkAllAsRead,
  animationClass,
}) => {
  return (
    <div className={`notification-wrapper ${animationClass}`}>
      <div className="notification-header">
        <h5>
          Notifications <span>({notViewedAlerts})</span>
        </h5>

        <button
          type="button"
          className="mark-all-read"
          onClick={onMarkAllAsRead}
        >
          Mark All As Read
        </button>
      </div>

      <div className="notification-divider" />

      <div className="notification-list">
        {allMessage.length > 0 ? (
          allMessage.map((value, index) => {
            return (
              <div
                key={value?.alertID ?? index}
                className="notification-link"
              >
                <div
                  className={`notification-item ${
                    !value?.viewed ? 'notification-unread' : ''
                  }`}
                >
                  <div className="notification-icon">
                    <FontAwesomeIcon icon={getNotificationIcon(value)} />
                  </div>

                  <div className="notification-content">
                    <div className="notification-message d-flex">
                      <div>
                        {truncateText(
                          `${value.lName} ${value.fName}${
                            value?.subject ? ': ' + value.subject : ''
                          }`
                        )}
                      </div>
                    </div>
                    <div className="notification-time">
                      <FontAwesomeIcon icon={faClock} />
                      <div>
                        {value?.timeAgo}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="notification-empty">
            No notifications
          </div>
        )}
      </div>

      <button
        className="btn btn-castleWhite w-100 mt-2"
        onClick={viewAllMessageHandler}
      >
        View All Notifications
      </button>
    </div>
  );
};

Notification.propTypes = {
  allMessage: PropTypes.array,
  notViewedAlerts: PropTypes.number,
  viewAllMessageHandler: PropTypes.func.isRequired,
  onMarkAllAsRead: PropTypes.func.isRequired,
  animationClass: PropTypes.string.isRequired
};
export default Notification;